import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

interface Props {
  tKey: string;
  disabled: boolean;
  onClick: () => void;
  isEditMode: boolean;
  isMarkedAsComplete?: boolean;
  wasOriginallyCompleted?: boolean;
  tooltipText?: string;
}

const SubmitButton: React.FC<Props> = ({
  tKey,
  disabled,
  onClick,
  isEditMode,
  isMarkedAsComplete = false,
  wasOriginallyCompleted = false,
  tooltipText
}) => {
  const { t } = useTranslation();

  const getButtonText = () => {
    if (isEditMode) {
      if (isMarkedAsComplete && !wasOriginallyCompleted) {
        return t(`${tKey}.saveAndComplete`);
      }
      return t(`${tKey}.save`);
    }
    if (isMarkedAsComplete) {
      return t(`${tKey}.createAndComplete`);
    }
    return t(`${tKey}.createNew`);
  };

  return (
    <Button
      data-test="submit-button"
      className="w-fit"
      disabled={disabled}
      onClick={onClick}
      tooltipText={tooltipText}
    >
      {getButtonText()}
    </Button>
  );
};

export default SubmitButton;
